import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { tokenState } from "@/state";
import { fcmTokenManager } from "@/utils/webviewUtil";

/**
 * FCM 토큰 동기화를 위한 커스텀 훅
 * 로그인 상태가 변경될 때마다 미등록된 FCM 토큰을 서버에 등록
 */
export const useFcmToken = () => {
  const token = useRecoilValue(tokenState);

  useEffect(() => {
    if (token && token.uid) {
      fcmTokenManager.processUnregisteredToken();
    }
  }, [token]);

  return {
    getCurrentToken: fcmTokenManager.getCurrentToken,
    getUnregisteredToken: fcmTokenManager.getUnregisteredToken,
    processUnregisteredToken: fcmTokenManager.processUnregisteredToken,
    processToken: fcmTokenManager.processToken,
  };
};

export default useFcmToken;
